import { Info } from 'lucide-react';
import { Inline } from '../../../../design-system/inline/inline';

export const AddressRequiredDisclaimer = () => {
  return (
    <div
      role="alert"
      aria-labelledby="address-disclaimer-title"
      className="rounded-lg border border-seapoint-gray-border bg-white p-4"
    >
      <Inline space={3} align="start" wrap="nowrap">
        <div className="h-10 w-10 overflow-clip rounded-full bg-seapoint-yellow/20 p-2.5" aria-hidden="true">
          <Info className="h-full w-full" color="black" />
        </div>

        <p id="address-disclaimer-title" className="flex-1 text-pretty text-sm font-medium text-black">
          For transfers to this country/region, we are required to collect the recipient's address before making the
          transfer. Please ensure this is correct before continuing.
        </p>
      </Inline>
    </div>
  );
};
